/**
 * Currently selected game mode on the TV lobby, with the entry to the mode carousel.
 *
 * `mode` is undefined when the session mode is missing from the mode list; the
 * card then shows only the button, so a valid mode can still be chosen.
 */

import { useTranslation } from 'react-i18next'
import { EmojiText } from '@/components/low/AnimatedEmoji'
import type { GameModeListItem } from '@/services/api'

interface SelectedModeCardProps {
  mode: GameModeListItem | undefined
  isChanging: boolean
  onChangeClick: () => void
}

export function SelectedModeCard({ mode, isChanging, onChangeClick }: SelectedModeCardProps) {
  const { t } = useTranslation()

  return (
    <div className="pixel-frame bg-card p-4 flex flex-col gap-3">
      <p className="text-[10px] uppercase tracking-[0.4em] text-muted-foreground font-black">
        {t('lobby.gameMode')}
      </p>
      {mode !== undefined && (
        <div className="flex items-center gap-3 min-w-0">
          <span className="text-4xl"><EmojiText>{mode.icon}</EmojiText></span>
          <p className="text-xl font-black uppercase tracking-wide text-foreground truncate">
            {mode.title}
          </p>
        </div>
      )}
      <button
        type="button"
        onClick={onChangeClick}
        disabled={isChanging}
        className="pixel-frame pixel-press self-start bg-primary text-primary-foreground px-4 py-2 text-xs font-black uppercase tracking-widest disabled:opacity-50"
      >
        {t('lobby.changeMode')}
      </button>
    </div>
  )
}
